import * as React from "react";
import { Loader2, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useImpersonationDialogContext } from "../ImpersonationContext";

export const SearchBar: React.FC = () => {
  const { isFetching, search, setSearch, handleKeyDown } = useImpersonationDialogContext();

  const isSafari = typeof window !== "undefined" && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  return (
    <div className="px-6 py-4.5 border-b border-slate-100 bg-white shrink-0 relative flex items-center">
      {isFetching ? (
        <Loader2 className="absolute left-6 top-1/2 -translate-y-1/2 h-6 w-6 text-indigo-500 animate-spin" />
      ) : (
        <Search className="absolute left-6 top-1/2 -translate-y-1/2 h-6 w-6 text-slate-400" />
      )}
      <Input
        className="pl-12 h-12 text-xl md:text-xl border-none focus:ring-0 focus-visible:ring-0 shadow-none placeholder:text-slate-400 text-slate-800 font-medium"
        placeholder="Search by name or email..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        onKeyDown={handleKeyDown}
        autoComplete={isSafari ? "off" : "one-time-code"}
        autoFocus
      />
    </div>
  );
};
